import { useEffect } from "react";

export function useCircularTab(containerRef,active = true) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const getFocusable = () =>
      container.querySelectorAll(
        'input, button, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

    const handleKeyDown = (e) => {
      if (e.key !== "Tab") return;

      const focusable = getFocusable();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        // Shift+Tab from first -> go to last
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        // Tab from last -> go to first
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    container.addEventListener("keydown", handleKeyDown);
    return () => container.removeEventListener("keydown", handleKeyDown);
  }, [containerRef,active]);
}
